import { ModalProps } from "antd";
import { useCallback } from "react";
import { Modal } from "react-bootstrap";
import { CloseIcon } from "src/assets/icons";
import "./index.scss";

const ModalLayoutMobile = (
  props: ModalProps & { onClose?: () => void; fullScreen?: boolean }
) => {
  const { onClose, fullScreen } = props;
  const lockScroll = useCallback(() => {
    document.body.style.position = "fixed";
  }, []);

  const unlockScroll = useCallback(() => {
    document.body.style.position = "";
  }, []);

  return (
    <Modal
      onShow={lockScroll}
      animation
      className="nafutel-popup-mobile"
      show={props.open}
      fullscreen={true}
      onHide={unlockScroll}
      scrollable
      backdrop="static"
      keyboard={false}
      enforceFocus={false}
      onExited={unlockScroll}
      contentClassName={fullScreen ? "" : "height-fit"}
    >
      <Modal.Header>
        <div className="transparent"></div>
        <div className="close-icon">
          <div> </div>
          <CloseIcon onClick={onClose} fill="#C1C1C1" />
        </div>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
      <Modal.Footer>{props.footer}</Modal.Footer>
    </Modal>
  );
};

export default ModalLayoutMobile;
